import React from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import SetNewPasswordStep from './SetNewPasswordStep';

// Landing page for the password-reset email link (see mailer.js's
// sendPasswordResetEmail / passwordReset.js's /send-link). The token in
// the URL is the proof of identity — sent straight through to /complete,
// same shape as ForgotPassword.jsx's phone-OTP path.

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:4001/api';

const page = {
  minHeight: '100vh',
  boxSizing: 'border-box',
  backgroundImage: 'url(/BESCOM_SSO_BG_Image.png)',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '20px',
};

const card = {
  background: 'rgba(255, 255, 255, 0.65)',
  backdropFilter: 'blur(12px)',
  WebkitBackdropFilter: 'blur(12px)',
  border: '1px solid rgba(255, 255, 255, 0.5)',
  borderRadius: '16px',
  padding: '48px 40px',
  width: '100%',
  maxWidth: '420px',
  boxShadow: '0 20px 60px rgba(0, 0, 0, 0.35)',
};

const btn = {
  width: '100%',
  padding: '14px',
  background: 'linear-gradient(135deg, #009FE3 0%, #0072B1 100%)',
  color: '#fff',
  border: 'none',
  borderRadius: '10px',
  fontSize: '16px',
  fontWeight: '600',
  cursor: 'pointer',
  marginTop: '8px',
};

export default function ResetPassword() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');
  const [done, setDone] = React.useState(false);

  return (
    <div style={page}>
      <div style={card}>
        <div style={{ textAlign: 'center', marginBottom: '24px' }}>
          <img src="/bescom-logo-ui.png" alt="BESCOM" style={{ width: '80px', marginBottom: '16px' }} />
          <h1 style={{ fontSize: '22px', fontWeight: '700', color: '#1a1a1a', margin: '0 0 8px' }}>
            {done ? 'Password reset' : 'Choose a new password'}
          </h1>
        </div>

        {!token && (
          <div style={{
            background: '#FDECEC', color: '#B3261E', padding: '10px 14px',
            borderRadius: '8px', fontSize: '13px', textAlign: 'center',
          }}>
            This reset link is missing its token.
          </div>
        )}

        {token && !done && (
          <SetNewPasswordStep
            onSubmit={async (password) => {
              const res = await fetch(`${API_BASE}/auth/password-reset/complete`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ resetToken: token, newPassword: password }),
              });
              const data = await res.json();
              return res.ok ? { ok: true } : { error: data.error };
            }}
            onSuccess={() => setDone(true)}
          />
        )}

        {done && (
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: '40px', marginBottom: '16px' }}>✅</div>
            <p style={{ color: '#1a1a1a', fontWeight: '600', marginBottom: '16px' }}>
              Your password has been reset.
            </p>
            <button onClick={() => navigate('/')} style={btn}>
              Go to Sign In
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
